import axios from 'axios';
import { apiPath } from 'constants/path';
import { IMDataResponse } from 'models/Common/commonApiTypes';
import { IMReportData } from 'models/Common/commonTypes';
import { createReportRequestType } from 'models/MTE/reportApiTypes';

export const header = {
    'Content-Type': 'application/json',
    Authorization: process.env.REACT_APP_ADMIN_KEY,
};

class BaseApi {
    constructor() {
        axios.defaults.headers.common['Authorization'] = process.env.REACT_APP_ADMIN_KEY;
        axios.interceptors.response.use((res) => res.data);
    }

    async post<T>(url: string, data: any, config?: any) {
        const res = await axios.post<T>(url, data, config);
        return res.data;
    }
    async get<T>(url: string) {
        const res = await axios.get<T>(url);
        return res.data;
    }
    async delete<T>(url: string) {
        const res = await axios.delete<T>(url);
        return res.data;
    }
}
export const api = new BaseApi();

class ReportApi {
    createReport(report: createReportRequestType): Promise<IMDataResponse<IMReportData>> {
        try {
            const response = api.post<IMDataResponse<IMReportData>>(apiPath.createReport, report);

            return response;
        } catch (error) {
            throw error;
        }
    }

    getReport(userId: string): Promise<IMDataResponse<IMReportData>> {
        try {
            const response = api.get<IMDataResponse<IMReportData>>(`${apiPath.getReport}/${userId}`);
            return response;
        } catch (e) {
            throw e;
        }
    }

    getAllReport(): Promise<IMDataResponse<IMReportData>[]> {
        try {
            const response = api.get<IMDataResponse<IMReportData>[]>(`${apiPath.getReport}`);
            return response;
        } catch (e) {
            throw e;
        }
    }

    deleteReport(reportId: string): Promise<IMDataResponse<IMReportData>> {
        try {
            const response = api.delete<IMDataResponse<IMReportData>>(`${apiPath.deleteReport}/${reportId}`);
            return response;
        } catch (e) {
            throw e;
        }
    }

    uploadReportFile(file: Blob, reportId: string): Promise<any> {
        const formData = new FormData();
        formData.append('file', file, 'report.pdf');
        return api.post(`${apiPath.uploadReport}/${reportId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
}
export const reportApi = new ReportApi();
